export default [
  {
    path: 'customer',
    name: 'customers.index',
    meta: {
      title: 'Clientes',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "customer" */ '../views/store/customer/Index.vue')
  },
  {
    path: 'customer/create',
    name: 'customers.create',
    meta: {
      title: 'Cadastrar um novo Cliente',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "customer" */ '../views/store/customer/Create.vue')
  },
  {
    path: 'customer/:id',
    name: 'customers.update',
    meta: {
      title: 'Cadastrar um novo Cliente',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "customer" */ '../views/store/customer/Create.vue')
  }
]
